module.exports = __webpack_public_path__ + "191206_Okko_deisel_Tuleni_15s_new_legal.mp4?1a94346d6449ac9ac5b3b257e4028944";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/191206_Okko_deisel_Tuleni_15s_new_legal.mp4
// module id = 142
// module chunks = 0